export default __webpack_public_path__ + "static/media/hello_woman.46a36507.png";